module.exports = __webpack_public_path__ + "img/گوشه-تیز.ff1cb1e5.png";